PaidAccount = require 'network/paid-account'
PopOver = require 'views/lib/pop-over'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
View = require 'view'
AdditionalDetailsComponent = require 'views/billing/form-sections/additional-details-component'
t = require('views/internal/recup-with-helpers')('credit_card')

module.exports = class ChangeAdditionalDetailsView extends View
  viewTitleKey: 'change additional details'

  renderOnce: ->
    @reactRoot ?= document.createElement('div')
    @$el.prepend @reactRoot
    @renderReactSection()

    @

  getReactRoot: ->
    React.createElement ReactRootComponent, {},
      @getFormComponent()


  renderReactSection: ->
    ReactDOM.render @getReactRoot(), @reactRoot

    @

  getFormComponent: ->
    t.render => t.div =>
      t.createElement AdditionalDetailsComponent,
        initialValue: @model.get('paidAccount').invoiceDetails
        onSubmit: (data) =>
          PaidAccount.changeInvoiceDetails(@model, data)
          .then (res) =>
            @model.set(res)
            PopOver.hide()
          .done()




// WEBPACK FOOTER //
// ./app/scripts/views/billing/change-additional-details-view.coffee